import { render, staticRenderFns } from "./AssessmentCompetenceEgrProTable.vue?vue&type=template&id=5fe67c02&scoped=true"
import script from "./AssessmentCompetenceEgrProTable.vue?vue&type=script&lang=js"
export * from "./AssessmentCompetenceEgrProTable.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCompetenceEgrProTable.vue?vue&type=style&index=0&id=5fe67c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe67c02",
  null
  
)

export default component.exports